import basic from "./version/basic";
import v1 from "./version/v1";
import v2 from "./version/v2";

export function basicVersion() { return basic }
export function v1Version() { return v1 }
export function v2Version() { return v2 }